"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class DealPartyModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            company: 'McLabs2__Transcation_Company__c',
            compId: 'McLabs2__Sale__c',
            contactId: 'McLabs2__Contact__c',
            contractId: 'McLabs2__Escrow__c',
            listingId: 'McLabs2__Listing__c',
            pursuitId: 'McLabs2__Proposal__c',
            role: 'McLabs2__Role__c',
            saleCap: 'McLabs2__Sale_CAP__c',
            saleDate: 'McLabs2__Sale_Date__c',
            salePriceSF: 'McLabs2__Sale_Price_SF__c',
            salePrice: 'McLabs2__Sale_Price__c',
            ownerId: 'OwnerId'
        };
    }
}
DealPartyModel.ROLES = {
    BUYER: 'Buyer',
    BUYER_ATTORNEY: 'Buyer attorney',
    BUYER_BROKER: 'Buyer broker',
    SELLER: 'Seller',
    SELLER_ATTORNEY: 'Seller attorney',
    SELLER_BROKER: 'Seller broker',
    TENANT: 'Tenant',
    TENANT_ATTORNEY: 'Tenant\'s attorney',
    TENANT_BROKER: 'Tenant\'s broker',
    LANDLORD: 'Landlord',
    LANDLORD_ATTORNEY: 'Landlord\'s attorney',
    LANDLORD_BROKER: 'Landlord\'s broker'
};
exports.DealPartyModel = DealPartyModel;
//# sourceMappingURL=deal-party.model.js.map